import { render, staticRenderFns } from "./supply.vue?vue&type=template&id=2758a140&scoped=true&"
import script from "./supply.vue?vue&type=script&lang=js&"
export * from "./supply.vue?vue&type=script&lang=js&"
import style0 from "./supply.vue?vue&type=style&index=0&id=2758a140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2758a140",
  null
  
)

export default component.exports